import React from "react";
import LoadingSpinner from "../../../components/LoadingSpinner";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronRight,
  faThumbsUp,
  faSearch,
} from "@fortawesome/free-solid-svg-icons";
import useFavouriteAthletes from "../../../hooks/useFavouriteAthletes";

export default function CoachCombineAthletesList({
  loading,
  searchQuery,
  onSearch,
  filteredAthletes,
  adjustedHeight,
  onAthleteClick,
  userRole,
}) {
  const { getFavoriteState, handleFavoriteClick } = useFavouriteAthletes();

  return (
    <div className="pb-0 mt-4">
      <h1 className="text-xl mb-2 uppercase">ATHLETES</h1>
      <div className="mb-4 flex items-center w-full border border-gray-300 rounded-md overflow-hidden">
        <input
          className="w-full p-2 shadow-sm focus:outline-none"
          type="text"
          value={searchQuery}
          onChange={onSearch}
          placeholder="Search athletes..."
        />
        <button
          type="button"
          className="basis-1/12 bg-white text-slate-500 flex items-center justify-center"
        >
          <FontAwesomeIcon icon={faSearch} size="md" />
        </button>
      </div>
      {loading ? (
        <LoadingSpinner />
      ) : (
        <ul
          className="list-none p-0 mt-4 overflow-y-auto pr-3 -mr-4"
          style={{ height: `${adjustedHeight + 30}px` }}
        >
          {filteredAthletes.length > 0 ? (
            filteredAthletes.map((athlete, index) => (
              <li
                key={athlete.userId ?? index}
                className="cursor-pointer p-2 hover:bg-gray-200 border-slate-500 border mb-4 rounded-md px-2 shrink-0"
                onClick={() => onAthleteClick(athlete)}
              >
                <div className="flex justify-between items-center">
                  <div className="flex flex-row flex-1">
                    <div className="my-auto rounded-md">
                      <img
                        alt="Athlete Name"
                        src={
                          athlete.profilePicture || "/default-profile-img.png"
                        }
                        className="grow-0 shrink-0 rounded-md h-[40px] w-[40px]"
                        height={40}
                        width={40}
                      />
                    </div>
                    <div className="ml-4">
                      <p className="text-lg uppercase">
                        {athlete.name} {athlete.lastname}
                      </p>
                      <p className="text-sm text-gray-700">
                        {athlete.position}
                      </p>
                    </div>
                  </div>

                  <button
                    type="button"
                    className="mr-6 text-[#8E8E93]"
                    aria-label={
                      getFavoriteState(athlete)
                        ? "Remove favorite"
                        : "Mark as favorite"
                    }
                    onClick={(event) => handleFavoriteClick(event, athlete)}
                  >
                    <div
                      className={`flex items-center justify-center h-[40px] w-[40px] rounded-full ${
                        getFavoriteState(athlete)
                          ? "bg-yellow-500"
                          : "bg-slate-400"
                      }`}
                    >
                      <FontAwesomeIcon
                        icon={faThumbsUp}
                        style={{ color: "#fff" }}
                      />
                    </div>
                  </button>
                  <div className="my-auto h-[40px] w-[40px] bg-blue-700 text-center text-white rounded-md hidden">
                    <p className="my-auto text-base mt-2 ">
                      {userRole === "athlete" || userRole === "admin"
                        ? athlete.trackittScore
                        : athlete.positionScore}
                    </p>
                  </div>
                  <button className="p-2 rounded ml-6">
                    <FontAwesomeIcon
                      icon={faChevronRight}
                      className="text-2xl font-bold"
                    />
                  </button>
                </div>
              </li>
            ))
          ) : (
            <div className="w-full p-2 mt-5 flex flex-col items-center">
              <img
                alt="No events that match your search"
                src="/nodata.gif"
                className="object-cover h-20 w-20 rounded-full border-gray-300 border"
              />

              <span className="mt-4 text-center text-md text-slate-600">
                There are no athletes that match your search
              </span>
            </div>
          )}
        </ul>
      )}
    </div>
  );
}
